import React from "react";
import { CalendarClock, Ship, Anchor, Route } from "lucide-react";
import SEO from "@/components/common/SEO";
import PageHero from "@/components/common/PageHero";
import TrackShipment from "@/components/common/TrackShipment";
import SectionHeading from "@/components/common/SectionHeading";
import { Reveal, Stagger, StaggerItem } from "@/components/common/Reveal";
import FinalCTA from "@/components/sections/FinalCTA";

const scheduleNotes = [
  { icon: Ship, title: "Sailing schedules", copy: "We coordinate suitable sailing schedules with carrier and forwarder partners based on your route and timing." },
  { icon: Anchor, title: "Port pairs & routing", copy: "Origin and destination port pairs are evaluated for transit time, frequency and cost." },
  { icon: Route, title: "Milestone updates", copy: "Once a booking is confirmed through a partner, we relay shipment milestones as they are shared with us." },
];

export default function Track() {
  return (
    <>
      <SEO
        title="Track Your Enquiry & Schedules | Premier Global Sourcing"
        description="Track the status of your sourcing or freight enquiry with Premier Global Sourcing using your reference number, and learn how sailing schedules are coordinated."
        path="/track"
      />
      <PageHero
        eyebrow="Track & schedules"
        title="Check your enquiry status"
        intro="Enter your enquiry reference number to see where your request is in our coordination process."
        breadcrumbs={[{ label: "Track & Schedules" }]}
      />

      <section className="container-page py-16 lg:py-20">
        <Reveal>
          <div className="rounded-lg border border-[#D9E0E4] bg-[#EAF1F4] p-6 lg:p-8">
            <div className="flex items-center gap-2 mb-4">
              <CalendarClock className="h-5 w-5 text-teal" />
              <h2 className="font-heading font-bold text-[18px] text-navy">Enquiry tracking</h2>
            </div>
            <TrackShipment />
          </div>
        </Reveal>
      </section>

      <section className="container-page pb-20 lg:pb-28">
        <SectionHeading
          eyebrow="Schedules & routing"
          title="How we handle schedules and shipment updates"
          intro="Premier Global Sourcing is a coordination partner, not a carrier. Sailing schedules and live shipment milestones are managed with the relevant qualified partner for each booking."
        />
        <Stagger className="mt-10 grid gap-px bg-[#D9E0E4] md:grid-cols-3 border border-[#D9E0E4] rounded-lg overflow-hidden">
          {scheduleNotes.map((s) => (
            <StaggerItem key={s.title}>
              <div className="h-full bg-white p-7">
                <s.icon className="h-6 w-6 text-teal" />
                <h3 className="mt-5 font-heading font-bold text-[17px] text-navy">{s.title}</h3>
                <p className="mt-2 text-[14.5px] leading-relaxed text-muted-foreground">{s.copy}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <FinalCTA />
    </>
  );
}
